import formInputMixin from './formInput';
import formInputCheckboxPropsMixin from './formInputCheckboxProps';

export default {
  mixins: [formInputMixin, formInputCheckboxPropsMixin],
  data () {
    return {
      proxyChecked: this.getProxyCheckedValue(),
    };
  },
  methods: {
    getProxyCheckedValue () {
      if (typeof this.value === typeof true) {
        return this.value;
      }

      return (this.value !== null) ? this.checked.includes(this.value) : !!this.checked;
    },
    clicked (event) {
      if (this.confirmRequired) {
        if (!confirm(this.confirmText)) {
          event.preventDefault();
          event.stopPropagation();

          return;
        }
      }

      this.emitCheck();
    },
    emitCheck () {
      if (this.value === null || typeof this.value === typeof true) {
        this.proxyChecked = !this.proxyChecked;
        this.$emit('input', this.proxyChecked);

        return;
      }

      const newValue = this.checked.filter(c => c !== this.value);
      if (!this.proxyChecked) {
        this.proxyChecked = true;
        newValue.push(this.value);
      }

      this.$emit('input', newValue);
    },
  },
};
